/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@glu/dropdown-react';
import { createUseStyles } from '@glu/theming';
import get from 'lodash/get';
import LocaleContext from '../../locale/LocaleContext';

import { getAmountTypeOptions } from '../../createPayment/CreatePayment.dropdowns';
import { getPaymentType } from '../../createPayment/CreatePayment.utils';
import { PAYMENT_TYPES } from '../../../constants';
import { getCalculations } from './PaymentInfo';
import WireContext from '../WireContext';

const styles = () => ({
  amountType: {
    margin: 0,
    '& > label, & div[data-qa=dropdown-position]': {
      width: '100%',
      margin: 0
    }
  }
});

const useStyles = createUseStyles(styles);

const AmountTypeComponent = ({
  action,
  data,
  formChange,
  formState,
  isTemplate,
  onParentUpdate
}) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();
  const wireContextState = useContext(WireContext);

  const id = get(
    formState.currency,
    '0.id',
    get(formState, 'currency.id', get(formState, 'currency'))
  );
  const currency = data.fxRates.find((x) => x.id === id);
  const usd = (currency && currency.currency === locale['common.usd']) || id === 1;
  const domestic =
    get(
      formState,
      'paymentType[0].type',
      getPaymentType(formState, data.paymentTypeOptions, { template: isTemplate })
    ) === PAYMENT_TYPES.WIRE.DOMESTIC;

  if (domestic || usd) {
    return null;
  }

  const value = get(formState, 'amountType.0.type', get(formState, 'amountType'));
  const instance = data.amountTypes.find((x) => x.type === value || x.id === value);

  const options = getAmountTypeOptions();

  const props = {
    key: 'amountType',
    name: 'amountType',
    id: 'amountType',
    dataQa: 'amountType',
    htmlId: 'amountType',
    labelText: locale['common.amountType'],
    format: (value) => {
      const v = get(value, '0') || data.amountTypes.find((x) => x.id === value);
      return (v && v.name) || '';
    },
    onChange: (_, value) => {
      const details = getCalculations({ ...formState, amountType: value }, data);
      const { currency, type } = details;
      const templateRelated = action.includes('template');
      formChange('amountTypeCurrency', get(value, '[0].type'));
      if (wireContextState && wireContextState.updateData) {
        wireContextState.updateData({ amountType: value });
      }
      onParentUpdate(details[type][templateRelated ? 'debit' : 'sent'], currency);
    },
    defaultValue: instance ? [instance] : [get(options, '0')],
    options,
    validators: [{ required: !isTemplate, msg: locale['validation.required'] }],
    placeholder: locale['common.select'],
    className: classes.amountType,
    filterEnabled: false
  };

  return (
    <div className="col-xs-3">
      <Dropdown {...props} />
    </div>
  );
};

AmountTypeComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  formChange: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  onParentUpdate: PropTypes.func.isRequired,
  isTemplate: PropTypes.bool.isRequired
};

export default AmountTypeComponent;
